"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CareMembershipStatus = void 0;
var CareMembershipStatus;
(function (CareMembershipStatus) {
    CareMembershipStatus["Active"] = "Active";
    CareMembershipStatus["NeverEnrolled"] = "NeverEnrolled";
    CareMembershipStatus["Canceled"] = "Canceled";
})(CareMembershipStatus = exports.CareMembershipStatus || (exports.CareMembershipStatus = {}));
//# sourceMappingURL=CareMembershipStatus.js.map